module.exports = __webpack_public_path__ + "img/ip_1.cae83a43.jpg";